import './legacy/textfill';
import './legacy/js-cookie';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import "./legacy/search";

import "./legacy/iframeResizer";

import "./legacy/popover";
import "./legacy/ajax-spinner";
import "./legacy/timeago";
import "./legacy/type_preference";
import "./legacy/articles";
import "./legacy/column_selector";
import "./legacy/mobile";
import "./legacy/price_chart_common";
import "./legacy/price";
import "./legacy/widget_price_compact";
import "./legacy/track";
import "./legacy/widget_deck";
import "./legacy/visual_deck";
import "./legacy/youtube_thumbs";
import "./legacy/spoiler_cards";
import "./legacy/spoiler_scrape_results";
import "./legacy/card_image_popover";
import "./legacy/card_tray";
import "./legacy/layout";
import "./legacy/deck_search";
import "./legacy/decks";
import "./deck_printing_picker";
import "./legacy/stripe-navigation";
import "./legacy/set_completion";
import "./legacy/privacy";
import "./legacy/dark";
import "./legacy/nested_forms";
import "./legacy/venatus_prosper";
import "./legacy/homepage_live_embed";
import "./legacy/on_ready";
